export const BASIC_MODAL = 'BASIC_MODAL';
export const CONFIRM_MODAL = 'CONFIRM_MODAL';
export const ABOUT_MODAL = 'ABOUT_MODAL';
export const XTRA_MOTION_SLOT_MODAL = 'XTRA_MOTION_SLOT_MODAL';
export const UPDATE_XTRA_MOTION_SLOT_MODAL = 'UPDATE_XTRA_MOTION_SLOT_MODAL';
export const CREDIT_ORDER_MODAL = 'CREDIT_ORDER_MODAL';